import React, { useState } from "react";
import { FiArrowLeft, FiUpload } from "react-icons/fi";

function ImageSearch({ onBack }) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [colorInputMethod, setColorInputMethod] = useState("radio"); // "radio" or "number"
  const [colorCount, setColorCount] = useState("");
  const [customColorCount, setCustomColorCount] = useState("");

  const handleSlider = (event) => {
    if ("vibrate" in navigator) {
      navigator.vibrate(50);
    }
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(file);
    } else {
      alert("Please select an image file");
    }
  };

  const handleColorCountChange = (event) => {
    setColorCount(event.target.value);
    setCustomColorCount(""); // Clear custom input when radio is selected
  };

  const handleCustomColorCountChange = (event) => {
    const value = event.target.value;
    // Allow only numbers between 1 and 20
    if (value === "" || (parseInt(value) >= 1 && parseInt(value) <= 20)) {
      setCustomColorCount(value);
      setColorCount(""); // Clear radio selection when custom input is used
    }
  };

  const handleInputMethodChange = (method) => {
    setColorInputMethod(method);
    setColorCount("");
    setCustomColorCount("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    
    if (!selectedFile) {
      alert("Please select an image to submit");
      return;
    }

    const finalColorCount = colorInputMethod === "radio" ? colorCount : customColorCount;
    if (!finalColorCount) {
      alert("Please specify the number of colors");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("image", selectedFile);
    formData.append("description", description);
    formData.append("n_colors", finalColorCount);

    try {
      const response = await fetch("http://127.0.0.1:5000/image", {
        method: "POST",
        body: formData,
      });

      if (response.ok) {
        const result = await response.text(); // Flask returns string of palette
        console.log("Color palette result:", result);
        alert("Image processed successfully! Check console for color palette results.");
        setSelectedFile(null);
        setPreviewUrl(null);
        setDescription("");
        setColorCount("");
        setCustomColorCount("");
      } else {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      console.error("Error submitting image:", error);
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        alert("Error: Unable to connect to the server. Please make sure the Flask server is running on http://192.168.1.25:5000");
      } else {
        alert("Error submitting image: " + error.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const isFormValid = selectedFile && (colorCount || customColorCount);

  return (
    <div className="search-container">
      <button className="back-button" onClick={onBack}>
        <FiArrowLeft />
      </button>
      <h2>Image Submission</h2>

      <form onSubmit={handleSubmit} className="image-form">
        <div className="image-grid-container">
          <div className="image-group">
            <input
              type="file"
              id="image-upload"
              accept="image/*"
              onChange={handleFileSelect}
              className="file-input"
            />
            <label htmlFor="image-upload" className="file-input-label">
              {previewUrl ? (
                <img src={previewUrl} alt="Preview" className="preview-image" />
              ) : (
                <div className="file-input-text">
                  <FiUpload size={48} />
                  <span>Click to select an image</span>
                  <small>Supports JPG, PNG, GIF</small>
                </div>
              )}
            </label>
          </div>

          <div className="image-inputs">
            <div className="color-selection-section">
              <h3 className="color-selection-title">Number of Colors</h3>
              
              {/* Input method selector */}

              {colorInputMethod === "radio" && (
                <div className="color-number-group">
                  <label className="color-button-label">
                    <input
                      type="radio"
                      name="colorCount"
                      value="1"
                      className="color-button"
                      checked={colorCount === "1"}
                      onChange={handleColorCountChange}
                    />
                    <span>1</span>
                  </label>

                  <label className="color-button-label">
                    <input
                      type="radio"
                      name="colorCount"
                      value="2"
                      className="color-button"
                      checked={colorCount === "2"}
                      onChange={handleColorCountChange}
                    />
                    <span>2</span>
                  </label>

                  <label className="color-button-label">
                    <input
                      type="radio"
                      name="colorCount"
                      value="3"
                      className="color-button"
                      checked={colorCount === "3"}
                      onChange={handleColorCountChange}
                    />
                    <span>3</span>
                  </label>

                  <label className="color-button-label">
                    <input
                      type="radio"
                      name="colorCount"
                      value="5"
                      className="color-button"
                      checked={colorCount === "5"}
                      onChange={handleColorCountChange}
                    />
                    <span>5</span>
                  </label>
                </div>
              )}

              {colorInputMethod === "number" && (
                <div className="number-input-section">
                  <label className="number-input-label">
                    Enter number of colors (1-20):
                  </label>
                  <input
                    type="number"
                    min="1"
                    max="20"
                    value={customColorCount}
                    onChange={handleCustomColorCountChange}
                    placeholder="e.g., 7"
                    className="number-input"
                  />
                </div>
              )}
            </div>

            <button
              type="submit"
              className="submit-button"
              disabled={loading || !isFormValid}
            >
              {loading ? "Submitting..." : "Submit Image"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ImageSearch;